/**
 * The slj brand mark, in stock Polaris neutrals (decision: no orange accent override).
 * Inline styles + token vars so this renders identically in the Hono document (static
 * polaris.css) and in React Router (vite-bundled polaris.css) with no CSS pipeline
 * of our own.
 */
export function LetterTile({letter, size = 32}: {letter: string; size?: number}) {
  return (
    <span
      aria-hidden
      style={{
        display: 'inline-grid',
        placeItems: 'center',
        width: size,
        height: size,
        borderRadius: 'var(--p-border-radius-200)',
        background: 'var(--p-color-bg-fill-brand)',
        color: 'var(--p-color-text-brand-on-bg-fill)',
        fontWeight: 700,
        fontSize: size * 0.48,
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      {letter}
    </span>
  );
}

export function BrandMark({size = 32}: {size?: number}) {
  return <LetterTile letter="S" size={size} />;
}

export function Brand({name = 'slj.app', size = 32}: {name?: string; size?: number}) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--p-space-200)',
        fontWeight: 650,
        fontSize: size * 0.55,
        letterSpacing: '-0.01em',
      }}
    >
      <BrandMark size={size} />
      <span>{name}</span>
    </span>
  );
}
